import { types } from 'mobx-state-tree';

const Team = types.model('Team', {
    id: types.identifierNumber,
    title: types.optional(types.string, ''),
    logo_url: types.maybeNull(types.string),
    is_owner: types.boolean,
    // League acronym (NL, SWHL, CHL, …) — shown next to the title in the
    // game-setup picker so same-club teams from different leagues are distinct.
    league_acronym: types.maybeNull(types.string),
});

export default Team;
